import { createSelector, MemoizedSelector } from '@ngrx/store';
import { FormsState } from '../state/pace-forms.state';
import { HistoricalValue } from '../../types/historical-value';
import { getForm } from './form.selector';

export const getHistoricalValues = createSelector(getForm, (form) => form.historicalValues);
export const getHistoricalValuesByUniqueIdFactory = (props: {
    uniqueId: string;
}): MemoizedSelector<FormsState, HistoricalValue[], (historicalValues: HistoricalValue[]) => HistoricalValue[]> =>
    createSelector(getHistoricalValues, (historicalValues: HistoricalValue[]) =>
        historicalValues.filter((historicalValue) => historicalValue.uniqueId === props.uniqueId),
    );
